import React from 'react';
import { ArrowRight, FileText } from 'lucide-react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl"
        >
          <div className="inline-flex items-center space-x-2 bg-slate-100 px-3 py-1 rounded-full mb-8">
            <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
            <span className="text-xs font-semibold text-slate-700 uppercase tracking-wide">Operated by Urban Web Host Pvt Ltd</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight text-slate-900 leading-tight mb-8">
            Structured Contribution.<br />
            Measurable Progress.<br />
            <span className="text-slate-500">Verified Experience.</span>
          </h1>
          
          <p className="text-xl text-slate-600 max-w-2xl mb-10 leading-relaxed">
            InternStacks is a remote internship ecosystem designed around contribution, governance, and technical accountability. This is not passive learning. This is contribution under structure.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a href="#apply" className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-white bg-slate-900 hover:bg-slate-800 transition-colors rounded-sm group">
              Apply for Internship
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a href="#governance-doc" className="inline-flex items-center justify-center px-8 py-4 text-base font-semibold text-slate-700 bg-white border border-slate-300 hover:bg-slate-50 transition-colors rounded-sm">
              <FileText className="mr-2 w-4 h-4" />
              Download Governance Overview
            </a>
          </div>
        </motion.div>
      </div>
      
      {/* Background decoration */}
      <div className="absolute top-0 right-0 -z-10 w-1/2 h-full opacity-5 pointer-events-none">
         <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
            <pattern id="grid" width="8" height="8" patternUnits="userSpaceOnUse">
                <path d="M 8 0 L 0 0 0 8" fill="none" stroke="currentColor" strokeWidth="0.5"/>
            </pattern>
            <rect width="100%" height="100%" fill="url(#grid)" />
         </svg>
      </div>
    </section>
  );
};

export default Hero;
